export default __webpack_public_path__ + "static/media/government.34137a41.svg";